import React, { Component } from "react";
import { Row, Col, Drawer, Input, Tooltip, Spin } from "antd";
import addIcon from "../images/GroupAdminAddicon.svg";
import close from "../images/GroupAdmincloseIcon.svg";
import addAllPlus from "../images/Addallplusbutton.svg";

export default class ListNpiTax extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  onSearch = (e) => {
    let e1 = e.target.value
    if (!e1) e1 = "" //to get exact results
    let _npis = []
    this.props.npisList.map(item => {
      const npi = String(item.npi); //
      if ( npi.includes(e1) || item.name.toLowerCase().includes(e1) || (e1 && item.name.toLowerCase().includes(e1.toLowerCase()))) {
        let count = this.props.selTaxNPIs.filter(sel => sel.npi === item.npi && !sel.delete).length
        if (count === 0) _npis.push(item)
      }
    })
    this.props.setNpisList(_npis)

  };

  getActiveNpisLen = () => {
    let npis = this.props.selTaxNPIs.filter(item => !item.delete)
    if (npis) return (npis.length).toString()
    else return "00"
  }

  calNpis = () => {
    let selVal = this.props.selTaxNPIs.filter(item => item.delete === false)
    return (this.props.npisList.length - selVal.length)
  }

  addAllNpiData = (items) => {
    // this.props.setNpisList(this.props.npisList)
    this.props.addTaxNPI(items, "All"); // items -> array of total npis
  };

  addNpiData = (item) => {
    this.props.addTaxNPI(item, "One"); // item -> one obj
  };

  submitHandler = () => {
    this.props.setselTaxNPIs(this.props.selTaxNPIs)
    this.props.closeDrawer();
  };

  removeNpi = (item) => {
    this.props.removeTaxNPI(item);
  };

  render() {
    const { Search } = Input;
    return (
      <div>
        {!this.props.isLoading && <Row>
          <Col span={14} className="dic-card p-3">
            <div>
              {this.props.totalTaxNPIs && parseInt(this.calNpis()) > 0 &&
                <Row>
                  <Col span={9}>
                    <button
                      className="butto-alluser pt-1 pb-1 pl-2 pr-2"
                      onClick={() =>
                        this.addAllNpiData(this.props.totalTaxNPIs)
                      }
                    >
                      Add All ({this.calNpis()})
                      <span className="ml-3">
                        <img src={addAllPlus}></img>
                      </span>
                    </button>
                  </Col>
                  <Col span={14} className="mb-2">
                    <Search
                style={{ height: "41px" }}
                placeholder={"Search by provider name or NPI"}
                enterButton="Search"
                size="large"
                // onSearch={handleSearch}
                // value={searchQuery}
               // onChange={this.onSearch}
                onChange={(e) => this.onSearch(e)}
              />
                  </Col>
                </Row>}

              {this.props.selTaxNPIs && this.calNpis() == 0 && <div className="Notification"
                style={{ textAlign: "center", marginTop: "20vh" }}>
                “All the available NPIs has been added for the available Tax
                ID”
              </div>
              }
            </div>

            <Row className="margin-chip">
              {this.props.totalTaxNPIs && this.props.totalTaxNPIs.length > 0 &&
                this.props.totalTaxNPIs.map((item, index) => {
                  return (
                    <Col span={7} className="npi-chip mr-4 mb-2 py-1" key={index}>
                      <Col className="npi-chip-text pl-2 pr-2 font-medium">
                        <Tooltip title={item.name} placement="bottom">
                          {item.npi}{" "}
                          {/* {item.name}{" "} */}
                          <span style={{ float: "right" }}>
                            <img
                              src={addIcon}
                              onClick={() => this.addNpiData(item)}
                            ></img>
                          </span>
                        </Tooltip>

                      </Col>
                    </Col>
                  );
                })}
            </Row>
          </Col>
          <Col span={9} className="ml-4 dic-card">
            <Row className="ml-1">
              <Col className="p-3">
                <Row>
                  <Col className="header-text">
                    {this.getActiveNpisLen()}
                    {this.getActiveNpisLen() > 1 ? ' NPIs Added' : ' NPI Added'}
                  </Col>
                </Row>
                <Row>
                  {this.props.selTaxNPIs.length == 0 ? (
                    <Col className="sub-text-npi" style={{ marginTop: "20vh" }}>
                      “Added NPIs will Appear Here”
                    </Col>
                  ) : (
                    <Row className="margin-npi-chip">
                      {this.props.selTaxNPIs && this.props.selTaxNPIs.length > 0 &&
                        this.props.selTaxNPIs.map((item, index) => {
                          if (!item.delete) {
                            return (
                              // <>
                              <Col span={10} className="npi-chip mr-4 py-1" key={index}>
                                <Col className="npi-chip-text pl-2 pr-1 font-medium" style={{width: "450px"}}>
                                  <Tooltip title={item.name} placement="bottom">
                                    {item.npi}{" "}
                                    <span style={{ float: "right"}}>
                                      <img
                                        src={close}
                                        onClick={() => this.removeNpi(item)}
                                      ></img>
                                    </span>
                                  </Tooltip>
                                </Col>
                              </Col>
                              // <>
                            );
                          }
                        })}
                    </Row>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>}

        {this.props.isLoading && <Row style={{
          textAlign: "center",
          marginTop: "3ovh"
        }}>
          <Spin size="large" />
        </Row>}
      </div>
    );
  }
}
